import { render, staticRenderFns } from "./PaymentAccountsLinking.vue?vue&type=template&id=5b76e154&"
import script from "./PaymentAccountsLinking.vue?vue&type=script&lang=js&"
export * from "./PaymentAccountsLinking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports